<template>
    <component :is="loaderComponent" />
</template>

<script>
import ALoader from '../../atoms/a-loader';
import ALoaderAc from '../../atoms/a-loader-ac';
import ALoaderH2h from '../../atoms/a-loader-h2h';

import {
    PLATFORM_AC,
    PLATFORM_H2H
} from '../../../utils/constants/theme-config-constants';
import { CONFIG } from '../../../utils/services/global-config-service';

export default {
    name: 'MLoader',
    computed: {
        loaderComponent() {
            const map = {
                [PLATFORM_AC]: ALoaderAc,
                [PLATFORM_H2H]: ALoaderH2h
            }
            return map[CONFIG.SCI_PLATFORM] || ALoader;
        }
    }
};
</script>
